import { configureStore } from '@reduxjs/toolkit';
import { api } from './api';
import authReducer from './auth';
import loggerReducer from './logger';

export const store = configureStore({
  reducer: {
    api: api.reducer,
    auth: authReducer,
    logger: loggerReducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware)
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
